export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8476.300f3ae6.jpg";